export enum TasksStepsEnum
{
    VET = 1,
    DueDiligence = 2,
    PSC = 3,
    Forms = 4,
    FBR = 5,
    INC = 6,
    GHG = 7,
    CFR = 8,
    INSP = 9,
    Review = 10,
    VoyageDataSubmission = 11,
    CrewWelfare = 12,
    AutoScreening = 13
}

export enum InspectorsStepsEnum
{
    Overview = 1,
    Inspectors = 2
}

export class TasksConstants
{
    public static TabsCacheKey: string = "tabs-activities";

    public static historyTaskTabKey: string = "items-name";
    
    public static PSCListName: string = "PSC";
    public static FBRListName: string = "Feedback Reports";
    public static CFRListName: string = "Condition for Review";
    public static INCListName: string = "INC";
    public static FormsListName: string = "Form Requests";
    public static CrewWelfareListName: string = "Crew Welfare";
    public static VETListName: string = "Vet Requests";
    public static DueDiligenceListName: string = "Due Diligence";
    public static VoyageDataSubmissionListName: string = "Carbon Accounting";
    public static SafetyRatingReviewListName: string = "Safety Rating Reviews";
    public static GHGListName: string = "Environmental Requests";
    public static INSPListName: string = "Inspections";
    public static AutoScreening: string = "Auto Screening";
    public static Reports: string = "Reports";
    public static TradeCheck: string = "Trade Check";
    public static VesselHealthCheck: string = "Vessel Health Check";
    public static PreArrivalCheck: string = "Pre-Arrival Check";

    //My subscription
    public static MySubscription: string = "my-subscription";
    public static InformationServices: string = "information-services";
    public static PscRiskIQ: string = "psc-riskIQ";
    public static MyVessels: string = "my-vessels";
    public static VesselChanges: string = "vessel-changes";
    public static MyCompanies: string = "my-companies";
    public static CompanyChanges: string = "company-changes";
}

export class InspectorsConstants
{
    public static TabsCacheKey: string = "tabs-inspectors";

    public static historyInspectorsTabKey: string = "items-name-inspectors";
    
    public static Overview: string = "Overview";
    public static InspectorsListName: string = "Inspectors";
}